import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faTrash, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import Swal from 'sweetalert2';
import { HealthService } from '../../../services/saude/health.service';
@Component({
  selector: 'app-excluir',
  templateUrl: './excluir.component.html',
  styleUrls: ['./excluir.component.css']
})
export class ExcluirComponent implements OnInit {
  //Icones
  faTriangleExclamation = faTriangleExclamation;
  faTrash = faTrash;
  //Variaveis locais
  beneficiaries!: any[];
  beneficiariosSelecionados!: any[];
  emails!: any[];
  plan!: any;
  loading: boolean = false;
  btnDisabled: boolean = true;
  enableTerms: boolean = false;
  termschecked: boolean = false;
  tooltipTerms: string = "Selecione pelo menos um dependente para prosseguir com a exclusão";
  titleTooltip: string = "Selecione o nome do(s) dependente(s) que deseja excluir";
  //Formulário
  formContact: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    confirm: new FormControl(false, [Validators.required])
  });
  constructor(private userService: UsuarioService, private tokenService: TokenService, private healthService: HealthService,
    private router: Router, private toast: ToastrService, private modalService: NgbModal) {
    this.getBeneficiaries();
  }
  ngOnInit(): void {
    this.beneficiariosSelecionados = this.beneficiaries.filter((item: any) => {
      if (item.titular == false) {
        return item;
      }
    });
  }
  protected getBeneficiaries(): void {
    // this.loadingBeneficiaries = true;
    this.healthService.getBeneficiaryAndHealthData().subscribe({
      next: (res: any) => {
        this.emails = [];
        this.beneficiaries = [];
        this.userService.getBeneficiaries().subscribe((res_second: any) => {
          res_second.forEach((element: any) => {
            if (element.titular) {
              this.userService.getUser(element.id).subscribe((res_third: any) => {
                this.emails.push(res_third.contactResponse.email);
                this.emails.push(res_third.contactResponse.secondaryEmail);
              });
            }
          })
        });
        res.forEach((element: any) => {
          if (element.titular) {
            this.plan = element.healthInsuranceName;
          }
          if (element.titular == false) {
            this.beneficiaries.push(
              {
                idSegurado: element.healthInsuranceContractNumber,
                name: element.name,
                cpf: element.cpf,
                titulariedade: element.titular
              }
            );
          }
        });
        // this.loadingBeneficiaries = false;
      },
      error: (error: any) => {
        // this.errorBeneficiaries = true;
      },
    }
    );
  }
  protected removeEmail(index: number): void {
    this.emails.splice(index, 1);
  }
  protected adicionarEmail(): void {
    if (this.formContact.value.email && !this.formContact.get('email')?.invalid) {
      this.emails.push(this.formContact.value.email);
      this.formContact.get('email')?.reset();
    }
  }
  confirmTerm() {
    this.loading = true;
    if (this.termschecked) {
      Swal.fire({
        title: 'Deseja prosseguir com a exclusão?',
        html: `<p>Declaro que, no ato da minha solicitação de exclusão do(s) dependente(s) ` + this.getSelecionados()
          + `, fui devidamente informado pela Fundação Copel das consequências relativas ao meu pedido de exclusão, protocolado nesta data e hora.</p>`,
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#1A428A",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim prosseguir",
        cancelButtonText: "Não"
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.healthService.postDeleteBeneficiary({ solicitationExclusion: this.beneficiaries.filter(a => a.selecionado == true), email: this.emails }).subscribe({
            next: (pdf: any) => {
              Swal.fire({
                title: "Solicitação enviada com sucesso!",
                text: "Em breve você receberá um e-mail com uma cópia do seu protocolo.",
                icon: "success",
                showConfirmButton: false,
              }).then(() => {
                this.downloadPdf(pdf);
                this.loading = false;
                window.location.reload();
              });
            },
            error: (err: any) => { }
          });
        }
      });
    }
  }
  getSelecionados() {
    let stringSelecionados = "";
    for (let beneficiary of this.beneficiaries) {
      if (beneficiary.selecionado) {
        stringSelecionados = stringSelecionados + beneficiary.name + ", ";
      }
    }
    return stringSelecionados.slice(0, -2);
  }
  isChecked() {
    let cancelTitular = this.beneficiaries.filter(a => a.selecionado == true);
    return cancelTitular && cancelTitular.length > 0;
  }
  checked(id: any) {
    this.beneficiaries.filter(a => a.idSegurado == id.currentTarget.id.split('_')[1]).forEach(element => {
      element.selecionado = !element.selecionado;
    });
    const anyIsChecked = this.isChecked();
    this.btnDisabled = !anyIsChecked;
    this.enableTerms = anyIsChecked;
    this.tooltipTerms = ((anyIsChecked) ? "" : "Selecione pelo menos um dependente para prosseguir com a exclusão");
  }
  changeTitleTooltip() {
    if (this.termschecked) {
      this.titleTooltip = "Para alterar os dependentes escolhidos, desmarque a opção de 'Estou ciente'";
    } else {
      this.titleTooltip = "Selecione o nome do(s) dependente(s) que deseja excluir";
    }
  }
  downloadPdf(pdf: any) {
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = 'Carta de Cancelamento.pdf';
    a.href = URL.createObjectURL(pdf.body);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }
}
